export default "__VITE_ASSET__hjh64X6F__"